export default __webpack_public_path__ + "static/media/orders-table-pending.d9b59ad3.svg";